import { Suspense } from 'react';

import { BrowserRouter as Router } from 'react-router-dom';

import SpinnerView from '@@/auto/components/SpinnerView';
import { useConfig } from '@@/common/services/useConfig';
import TenantTheme from '@@/common/themes/TenantTheme';

import { Authn } from './Authn';
import Routes from './Routes';

export default function ToggleRouter() {
  const { config, hasLoaded: hasConfigLoaded } = useConfig();

  if (!hasConfigLoaded) {
    return <SpinnerView data-testid="App_spinner" />;
  }

  return (
    <TenantTheme cssFiles={config.cssFiles}>
      <Router>
        <Suspense
          fallback={<SpinnerView data-testid="suspense_fallback_spinnerView" />}
        >
          <Authn>
            <Routes />
          </Authn>
        </Suspense>
      </Router>
    </TenantTheme>
  );
}
